import type { CSSProperties, MouseEvent } from "react";
import type { ButtonVariants, Colors } from "@miplatform/types";
import { mdiFormatListBulleted } from "@mdi/js";
import { Box, TypographyProps } from "@mui/material";
import { MiButton } from "../MiButton/MiButton";
import { MiPlaceholderIcon } from "../MiPlaceholderIcon/MiPlaceholderIcon";

interface MiPlaceholderListProps {
  text?: string;
  helperText?: string;
  iconColor?: string;
  iconBgColor?: string;
  image?: string;
  textProps?: TypographyProps;
  helperTextProps?: TypographyProps;
  icon?: string;
  containerStyle?: CSSProperties;
  actions?: {
    title: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    variant?: ButtonVariants;
    color?: Colors;
    disabled?: boolean;
    startIcon?: string;
    endIcon?: string;
  }[];
}

export const MiPlaceholderList = ({
  text = "",
  helperText = "",
  iconColor = "",
  iconBgColor = "",
  image,
  textProps,
  helperTextProps,
  icon = mdiFormatListBulleted,
  containerStyle,
  actions = [],
}: MiPlaceholderListProps) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    style={{ height: "100%", ...containerStyle }}
  >
    <MiPlaceholderIcon
      image={image}
      icon={icon}
      iconColor={iconColor}
      iconBgColor={iconBgColor}
      text={text}
      helperText={helperText}
      textProps={textProps}
      helperTextProps={helperTextProps}
    />
    <Box pt={2} display="flex">
      {actions.map((action) => (
        <MiButton
          key={action.title}
          title={action.title}
          onClick={action.onClick}
          variant={action.variant}
          color={action.color}
          disabled={action.disabled}
          startIcon={
            action.startIcon
              ? {
                  path: action.startIcon,
                  iconSize: 0.8,
                }
              : undefined
          }
          endIcon={
            action.endIcon
              ? {
                  path: action.endIcon,
                  iconSize: 0.8,
                }
              : undefined
          }
        />
      ))}
    </Box>
  </Box>
);
